/**
 * Rolled Steel Beam Sections - Dimensions and Properties
 * Data source: "Rolled Steel Beam sections dimensions and properties"
 */

export interface RolledSteelBeamData {
  designation: string;           // e.g., "ISJB 150"
  w: number;                      // Weight (kg/m)
  a: number;                      // Area (cm2)
  h: number;                      // Depth (mm)
  b: number;                      // Width (mm)
  tf: number;                     // Flange Thickness (mm)
  tw: number;                     // Web Thickness (mm)
  Ixx: number;                    // Moment of Inertia about X-X (cm4)
  Iyy: number;                    // Moment of Inertia about Y-Y (cm4)
  rxx: number;                    // Radius of Gyration about X-X (cm)
  ryy: number;                    // Radius of Gyration about Y-Y (cm)
  Zxx: number;                    // Section Modulus about X-X (cm3)
  Zyy: number;                    // Section Modulus about Y-Y (cm3)
  r1: number;                     // Root Radius (mm)
  r2: number;                     // Toe Radius (mm)
  D: number;                      // Flange Slope (degrees)
  h1: number;                     // Connection Detail h1 (mm)
  h2: number;                     // Connection Detail h2 (mm)
  b1: number;                     // Connection Detail b1 (mm)
  C: number;                      // Connection Detail C (mm)
  g: number;                      // Connection Detail g (mm)
  g1Min: number;                  // Connection Detail g1 Min (mm)
  maxRivet: number;               // Maximum Size of Flange Rivet (mm)
}

/**
 * Complete dataset of Rolled Steel I-Beam sections
 * Add more sections as needed
 */
export const rolledSteelBeamSections: RolledSteelBeamData[] = [
  {
    designation: "ISJB 150",
    w: 7.1,
    a: 9.01,
    h: 150,
    b: 50,
    tf: 4.6,
    tw: 3,
    Ixx: 322.1,
    Iyy: 9.2,
    rxx: 5.98,
    ryy: 1.01,
    Zxx: 42.9,
    Zyy: 3.7,
    r1: 5,
    r2: 1.5,
    D: 91.5,
    h1: 130.4,
    h2: 9.8,
    b1: 23.5,
    C: 3,
    g: 30,
    g1Min: 45,
    maxRivet: 6
  },
  {
    designation: "ISJB 175",
    w: 8.1,
    a: 10.28,
    h: 175,
    b: 50,
    tf: 4.8,
    tw: 3.2,
    Ixx: 479.3,
    Iyy: 9.7,
    rxx: 6.83,
    ryy: 0.97,
    Zxx: 54.8,
    Zyy: 3.9,
    r1: 5,
    r2: 1.5,
    D: 91.5,
    h1: 155,
    h2: 10,
    b1: 23.4,
    C: 3.1,
    g: 30,
    g1Min: 45,
    maxRivet: 6
  },
  {
    designation: "ISJB 200",
    w: 9.9,
    a: 12.64,
    h: 200,
    b: 60,
    tf: 5,
    tw: 3.4,
    Ixx: 780.7,
    Iyy: 17.3,
    rxx: 7.86,
    ryy: 1.17,
    Zxx: 78.1,
    Zyy: 5.8,
    r1: 5,
    r2: 1.5,
    D: 91.5,
    h1: 179.5,
    h2: 10.25,
    b1: 28.38,
    C: 3.2,
    g: 30,
    g1Min: 45,
    maxRivet: 6
  },
  {
    designation: "ISJB 225",
    w: 12.8,
    a: 16.28,
    h: 225,
    b: 80,
    tf: 5,
    tw: 3.7,
    Ixx: 1308.5,
    Iyy: 40.5,
    rxx: 8.97,
    ryy: 1.58,
    Zxx: 116.3,
    Zyy: 10.1,
    r1: 6.5,
    r2: 1.5,
    D: 91.5,
    h1: 201.1,
    h2: 11.95,
    b1: 38.15,
    C: 3.35,
    g: 40,
    g1Min: 45,
    maxRivet: 12
  }
];

/**
 * Get beam data by designation
 */
export const getRolledSteelBeamByDesignation = (designation: string): RolledSteelBeamData | undefined => {
  return rolledSteelBeamSections.find(beam => beam.designation === designation);
};

/**
 * Get all available designations
 */
export const getRolledSteelBeamDesignations = (): string[] => {
  return rolledSteelBeamSections.map(beam => beam.designation);
};
